import { DispatchMethods } from "../components/form/enums";
import { displayElement } from "./display";

function filterStages(stages, state, globalState) {
  return stages.filter((s) =>
    displayElement(s, state, null, globalState)
  );
}

function getOverviewIndex(stages) {
  return stages.length > 1 ? stages.length + 1 : 1;
}

function getStageNames(stages) {
  const stagesToRender = getStagesToRender(stages);
  return stagesToRender
    .map((stage) => stage.title)
    .concat("Overview");
}

function getStagesToRender(stages) {
  return stages.filter((stage) =>
    typeof stage.renderStage !== "undefined"
      ? stage.renderStage
      : true
  );
}

function selectStage(dispatch, stage, state) {
  // only allow a previous stage to be selected
  if (stage >= state.stage) {
    return;
  }

  dispatch({
    type: DispatchMethods.SetStage,
    stage: stage,
    formData: state.formData,
  });
}

export {
  filterStages,
  getOverviewIndex,
  getStageNames,
  getStagesToRender,
  selectStage,
};
